<script setup lang="ts">
const { $localeSync } = useNuxtApp()
const locale = useLocale()

const ui = computed(() => {
  const langCurrent = locale.value
  return STORE_LANGUAGES.find(({ iso }) => iso === langCurrent) || STORE_LANGUAGES[0]
})

const auth = useAuth()
const countryTitle = computed((): string | None => auth.value.addressDefault?.countryName?.value)
const iso2 = computed((): string => auth.value.addressDefault?.iso2 || 'lt')

const next = computed(() => {
  const iso = ui.value.iso
  const size = STORE_LANGUAGES.length
  return STORE_LANGUAGES[(STORE_LANGUAGES.findIndex((i) => i.iso === iso) + 1) % size]?.iso || 'en'
})
</script>

<template>
  <button :key="locale" type="button" :class="$style.a" :aria-label="ts('Change language to', next)" @click="$localeSync('from:AppLanguageUi', next)">
    <span v-if="countryTitle" class="_relative _h14 _mr04">{{ countryTitle }}</span>
    <UiCountryImg :iso2 />
    <span v-if="countryTitle" class="_mr04 _ml04">/</span>
    <span :class="$style.n">{{ ui.iso }}</span>
  </button>
</template>

<style module>
.a {
  composes: global(_row);
  composes: global(_ctrY);
  composes: global(_mr04);
  composes: global(_txt_end);
  composes: global(_end);

  color: inherit;
  letter-spacing: inherit;
}
.n {
  composes: global(_ctr);
  composes: global(txt_upper);
  composes: global(_fs07);
  composes: global(_fw-xxl);
  composes: global(_h18);
  composes: global(_mr04);

  composes: global(_c1);
  composes: global(_b1);

  border-radius: 6px/5px;
  width: 22px;
}
</style>
